import { render, staticRenderFns } from "./addsale.vue?vue&type=template&id=52856864&scoped=true"
import script from "./addsale.vue?vue&type=script&lang=js"
export * from "./addsale.vue?vue&type=script&lang=js"
import style0 from "./addsale.vue?vue&type=style&index=0&id=52856864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52856864",
  null
  
)

export default component.exports